import mstore from '@/store/meeting-store'

export default {
  logoff_kyoutu () {
    let meetingSession = mstore.getters.meetingSession
    let myselfVideoElm
    if (meetingSession !== null) {
      if (JSON.parse(localStorage.isOnlineMeeting) === true) {
        if (sessionStorage.customerType === 'guest') {
          myselfVideoElm = document.getElementById('guest1')
        } else {
          myselfVideoElm = document.getElementById('myself')
        }
        meetingSession.audioVideo.chooseVideoInputDevice(null)
        meetingSession.audioVideo.stopLocalVideoTile()
        meetingSession.audioVideo.stopVideoPreviewForVideoInput(myselfVideoElm)
      }
      meetingSession.audioVideo.stopContentShare()
      meetingSession.audioVideo.stop()
      mstore.commit('setMeetingSession', null)
      mstore.commit('setMyselfVideo', null)
      mstore.commit('setYourselfVideo', null)
      mstore.commit('setGuest1selfVideo', null)
      mstore.commit('setGuest2selfVideo', null)
      mstore.commit('setGuest3selfVideo', null)
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/mixins/logoff.js